import COS from 'cos-js-sdk-v5'
export default class VzanUpload {
  constructor(zbid) {
    this.Region = 'ap-guangzhou'
    // 其他存储桶
    this.Bucket = 'i3-1251575313'
    this.Host = 'https://i3.vzan.com/'
    // 图片存储桶
    this.imageBucket = 'i2-1251575313'
    this.imageHost = 'https://i2.vzan.com/'

    this.zbid = zbid || window.zbvd.zbid
    this.filename = ''
    this.cos = new COS()
  }

  // 获取上传文件签名
  getAuthorization(fileName) {
    var url = `/liveajax/Credential?zbid=${this.zbid}&prefix=${fileName.replace(
      '.mpeg',
      '.mp3'
    )}`
    return new Promise((resolve, reject) => {
      window.$.ajax({
        url,
        method: 'GET',
        xhrFields: {
          withCredentials: true,
        },
        dataType: 'JSON',
        success: resolve,
        error: reject,
      })
    })
  }

  // 验证上传文件
  valideFileConfig(fileType, fileExe, config) {
    let msg = ''
    if (fileType.includes('image')) {
      // 图片
      const fileTypesArr = config.fileTypes || ['jpeg', 'jpg', 'png', 'bmp']
      if (!fileTypesArr.includes(fileExe)) {
        msg = `该文件类型不支持，请上传${fileTypesArr.join(',')}文件`
      }
    } else if (config.fileTypes && config.fileTypes.includes('excel')) {
      if (!fileExe.includes('sheet') && !fileExe.includes('excel')) {
        // excel 表格
        msg = `该文件类型不支持，请上传 Excel xls 文件`
      }
    } else if (config.fileTypes && config.fileTypes == 'mp3') {
      const audioList = ['m4a', 'mp3']
      const validList = ['mpeg', 'x-m4a', 'mp3', 'm4a'] // 后缀名校验
      if (!validList.includes(fileExe)) {
        msg = `该文件类型不支持，请上传${audioList.join(',')}文件`
      }
    } else if (config.fileTypes && config.fileTypes == 'mp4') {
      // 视频文件
      const fileTypesArr = config.fileTypes || ['mp4']
      if (!fileTypesArr.includes(fileExe)) {
        msg = `该文件类型不支持，请上传${fileTypesArr.join(',')}文件`
      }
    }
    return { msg }
  }

  // 上传图片
  uploadImage(inputEvent, config = {}, isCompress = false) {
    return this.uploadFile(inputEvent, config, isCompress)
  }

  // 上传文件
  async uploadFile(inputEvent, config = {}, isCompress = false) {
    let fileObject = null
    if (isCompress) {
      fileObject = inputEvent
    } else {
      fileObject = inputEvent.target.files[0]
    }
    if (!fileObject) {
      // eslint-disable-next-line no-throw-literal
      throw '找不到改文件'
    }
    const isRAR =
      fileObject.name.split('').slice(-4, fileObject.name.length).join('') ===
      '.rar'
    const fileType = isRAR ? 'application/x-rar-compressed' : fileObject.type
    console.log(fileObject)
    console.log(`fileObject --->`)
    console.log('fileType:' + fileType)
    let fileExe = fileType.split('/')[1]
    // 有文件名的前提对后缀名统一处理
    if (fileObject.name && config.nameExe) {
      let fileArr = fileObject.name.split('.')
      fileExe = fileArr[fileArr.length - 1]
    }
    const { msg } = this.valideFileConfig(fileType, fileExe, config)
    if (msg) {
      throw msg
    }
    var filesize = parseFloat(fileObject.size / 1024 / 1024)
    const maxSize = config.maxSize || 100
    if (filesize > maxSize) {
      // eslint-disable-next-line no-throw-literal
      // throw `上传文件不能超过${maxSize}MB`
      return Promise.reject(`上传文件不能超过${maxSize}MB`)
    }
    try {
      // excel 文件格式 扩展名转换
      if (fileExe.includes('excel') || fileExe.includes('sheet')) {
        fileExe = 'xls'
      }
      if (fileExe.includes('.document')) {
        fileExe = 'doc'
      }
      // ios 手机上传视频 文件格式 扩展名转换
      console.log(fileExe)
      console.log(`fileExe ---->`)
      if (fileExe.includes('presentation')) {
        fileExe = 'pptx'
      }
      if (fileExe.includes('MOV')) {
        fileExe = 'mp4'
      }
      if (fileExe.includes('quicktime')) {
        fileExe = 'mp4'
      }
      if (fileExe && fileExe.includes('zip')) {
        fileExe = 'zip'
      }
      if (fileObject.name.includes('.rar')) {
        fileExe = 'rar'
      }
      if (fileExe && (fileExe.includes('doc') || fileExe.includes('msword'))) {
        fileExe = 'doc'
      }
      // 如果大小小于指定的大小时，走接口上传
      !window.webConfigs && (await this.getUploadConfig())
      let configObj = this.getFileType(fileExe)
      let iInterface =
        window.webConfigs &&
        window.webConfigs[configObj.configType] &&
        window.webConfigs[configObj.configType].isInterface
      if (iInterface) {
        let limit =
          window.webConfigs &&
          window.webConfigs[configObj.configType] &&
          window.webConfigs[configObj.configType].limitMax
        if (filesize <= limit) {
          let fromType
          if (!isCompress) {
            inputEvent.target.value = null
            fromType = inputEvent.target.dataset.type
          }
          return await this.inputUploadFiles(fileObject, config, {
            fromType,
            fileType,
            uploadType: configObj.interType,
            limit,
          })
        }
      }
      // 随机文件名
      this.filename = `${Math.random().toString(36).substr(2)}.${fileExe}`
      console.log(this.filename)
      // 获取签名
      const auth = await this.getAuthorization(this.filename)
      console.log(auth, '签名')
      this.cos.options.SecretId = auth.TmpSecretId
      this.cos.options.SecretKey = auth.TmpSecretKey
      this.cos.options.XCosSecurityToken = auth.Token
      this.cos.options.ExpiredTime = auth.ExpiredTime
      this.filename = auth.folder
      this.Bucket = auth.bucket
      this.Host = auth.host
    } catch (error) {
      // eslint-disable-next-line no-throw-literal
      throw '上传路中出错了，请稍候再试试~'
    }
    return new Promise((rseolve, reject) => {
      let fromType
      if (!isCompress) {
        inputEvent.target.value = null
        // $(event.target.id).val('');
        fromType = inputEvent.target.dataset.type
      }
      // 本地调试会跟腾讯云跨域，所以本地则返回固定值
      if (
        location.host.includes('local') ||
        location.host.includes('192.168.')
      ) {
        let res = {
          src: 'http://i2.vzan.com/image/liveimg/jpeg/2020/2/4/1530198e48d989dba8404890e148c65fb212b2.jpeg',
          fileType: 'image/png',
          fileExe: 'png',
          fromType,
          fileSize: 251621,
          fileSizeFormat: '0.02MB',
          fileName: 'xxx.png',
        }
        if (config.fileTypes == 'mp4') {
          res.src =
            'https://static2.sinsam.com/zhibo/userlivecontent/vzan/video/vzan.mp4'
          res.fileType = 'video/mp4'
        } else if (config.fileTypes == 'mp3') {
          res.src =
            'http://i3.vzan.com/mp3/20200831/3bbcbcd493d040c391a678b691613ff9/v.f1010.mp3'
        }
        rseolve(res)
      } else {
        let uploadConfig = {
          Bucket: this.Bucket,
          Region: this.Region,
          Key: this.filename,
          Body: fileObject, // 文件对象
          // onTaskReady return taskId
          onProgress: progressData => {
            // 进度
            var progress = parseInt(progressData.percent * 100)
            config.onProgress && config.onProgress(progress)
          },
        }
        if (config.downloadName) {
          uploadConfig.Headers = {
            'Content-Disposition':
              'attachment;filename="' +
              encodeURIComponent(config.downloadName) +
              '"',
          }
        }
        // 切片上传
        this.cos.sliceUploadFile(uploadConfig, (err, data) => {
          if (err) {
            console.log(err)
            reject('上传失败请重试')
          } else {
            console.log(data)
            const imageUploadUrl = `${this.Host}/${data.Key}`
            const imageInfo = {
              src: imageUploadUrl,
              fileType,
              fileExe,
              fromType,
              fileSize: fileObject.size,
              fileSizeFormat: `${(fileObject.size / 1024 / 1024).toFixed(2)}MB`,
              fileName: fileObject.name || '未知文件',
            }
            rseolve(imageInfo)
          }
        })
      }
    })
  }

  cancelAll() {
    // 取消所有上传任务
    const list = this.cos.getTaskList()
    list.reverse().forEach(i => {
      this.cos.cancelTask(i.id)
    })
  }

  // 获取上传的类型
  getFileType(exe) {
    let configType = ''
    let interType = ''
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(exe)) {
      configType = 'uploadImage'
      interType = 'image'
    } else if (
      [
        'rar',
        'zip',
        'txt',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'pdf',
      ].includes(exe)
    ) {
      configType = 'uploadFile'
      interType = 'file'
    } else if (['mp3', 'm4a'].includes(exe)) {
      configType = 'uploadAudio'
      interType = 'audio'
    } else if (['mp4'].includes(exe)) {
      configType = 'uploadVideo'
      interType = 'video'
    }
    return { configType, interType }
  }
  // 获取上传配置
  getUploadConfig() {
    return new Promise(resolve => {
      $.getScript(
        'https://static2.sinsam.com/zhibo/static/source/gray/web-config.js',
        function (res) {
          resolve()
        }
      )
    })
  }
  // 接口上传图片
  inputUploadFiles(file, config, obj) {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('file', file)
      $.ajax({
        url: `/liveajax/upload?zbid=${this.zbid}&type=${obj.uploadType}`,
        data: formData,
        method: 'POST',
        processData: false,
        contentType: false,
        xhr: function () {
          var myXhr = $.ajaxSettings.xhr()
          if (myXhr.upload) {
            myXhr.upload.addEventListener(
              'progress',
              function (e) {
                if (e.lengthComputable) {
                  config.onProgress &&
                    config.onProgress(
                      Number(((e.loaded / e.total) * 100).toFixed(2))
                    )
                }
              },
              false
            )
          }
          return myXhr
        },
        success: res => {
          console.log(res)
          if (res && res.isok) {
            const imageInfo = {
              src: res.dataObj.url,
              fileType: obj.fileType,
              fromType: obj.fromType,
              fileExe: res.dataObj.fileExt,
              fileSize: res.dataObj.fileSize,
              fileSizeFormat: `${(res.dataObj.fileSize / 1024 / 1024).toFixed(
                2
              )}MB`,
              fileName: file.name || '未知文件',
            }
            resolve(imageInfo)
          } else {
            reject(res.msg)
          }
        },
      })
    })
  }
}
